var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a', {
    staticClass: "live-video-item",
    attrs: {
      "skel-type": "1",
      "skel-style": "transform:scale(0.5, 0.8);"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.getLiveRoomLink(_vm.vdoid);
      }
    }
  }, [_c('div', {
    staticClass: "item-wrap"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image.scrollBox",
      value: _vm.getCover(),
      expression: "getCover()",
      arg: "background-image",
      modifiers: {
        "scrollBox": true
      }
    }],
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "heat"
  }, [_vm._v(_vm._s(_vm.heat))]), _vm._v(" "), _c('div', {
    staticClass: "bottom-area"
  }, [_c('div', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.desc))]), _vm._v(" "), _c('div', {
    staticClass: "nickname"
  }, [_vm._v(_vm._s(_vm.nickname))])])]), _vm._v(" "), _vm._m(0)])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mask"
  }, [_c('i', {
    staticClass: "mask-play"
  })]);
}];
export { render, staticRenderFns };